import { createFileRoute } from '@tanstack/react-router';
import { ParentSigningPage } from '../../components/signing/ParentSigningPage';

export const Route = createFileRoute('/sign/$token')({
  component: Page,
});

function Page() {
  const { token } = Route.useParams();
  return <ParentSigningPage accessToken={token} />;
}
